<template>
    <div></div>
</template>

<script>

import Core from "../../core/core";

export default {
    data() {
        return {
        };
    },
    components: {
    },
    mounted(){
        let loginKey = this.$route.query.key
        this.loginByKey(loginKey)
        console.log('query', this.$route.query);
    },
    methods: {
        loginByKey(loginKey) {
            if (!loginKey) {
                return this.$message.warning("login key is null")
            }
            let loading = this.$loading({
                lock: true,
                text: 'Loading...'
            })
            let num = 1
            let task = setInterval(() => {
                console.log(`等待300毫秒 读取后端配置 第${num++}次`);
                if (Core.Const.NET.GET_CONFIG_OVER) {
                    Core.Api.User.loginByKey(loginKey).then(res => {
                        this.loginSuccess(res)
                    }).catch(e => {
                        this.$message.error("免登失败")
                        this.$router.replace("/login")
                    }).finally(_ => {
                        loading.close()
                    })
                    clearInterval(task)
                }
            }, 300)
        },
        loginSuccess(res) {
            let { user, token } = res;
            Core.Data.setToken(token);
            Core.Data.setUser(user);
            user.role === 1 ? this.$router.push('/home') : user.role === 2 ? this.$router.push('/storage') : this.$router.push('/home');
        },
    }
}
</script>

<style scoped>

</style>